enum ExploreMarket {
  Primary = "Primary",
  Secondary = "Secondary",
}

export default ExploreMarket;
